
import jsonAPI from './json-api'

class Auth {
  constructor () {
    this._conf = {}
  }

  loginV2 (account) {
    return jsonAPI.request('/loginV2', account, {...this._conf, method: 'post'}).then(this._handleAuthInfo)
  }

  login (account) {
    return jsonAPI.request('/login', account, {...this._conf, method: 'post'}).then(this._handleAuthInfo)
  }

  // logout() {
  //     return jsonAPI.request('/logout', {}, this._conf).then(this._logout)
  // }

  userInfo () {
    return jsonAPI.requestWithAuth('/getUserInfo', {}, {...this._conf, method: 'post'})
  }

  renew () {
    return jsonAPI.requestWithAuth('/auth/renew', {}, this._conf).then(this._handleAuthInfo)
  }

  logout () {
    jsonAPI.clearAuthInfo()
  }

  setAuthInfo ({ access_token: token }) {
    jsonAPI.setAuthInfo(token)
  }

  get authHeader () {
    return jsonAPI.authHeader
  }

  _handleAuthInfo (data) {
    if (data && data.access_token) {
      jsonAPI.setAuthInfo(data.access_token)
      return data
    }
    return null
  }
}

export default new Auth()
